import logo from "../logo.svg";
const projects = [
  {
    name: "AI Tutoring App",
    repoLink: "",
    screenshot: "images/inquizitive.png",
    tags: ["Spotlight", "Productivity"],
    description:
      "A dynamic quiz-making application that integrated OpenAI API for tailored quiz content, delivering a personalized user experience.",
    liveUrl: "https://quizcraft-tau.vercel.app/",
  },
  {
    name: "CyberShock Music",
    repoLink: "",
    screenshot: "images/cyberShock.png",

    tags: ["Spotlight", "Lifestyle"],
    description:
      "Promotes the events of an upcoming live DJ music group, based in Columbus Ohio.",
    liveUrl: "https://www.cybershockmusic.com/",
  },
  {
    name: "FoodMental",
    repoLink: "",
    screenshot: "images/FoodMental.png",
    tags: ["Spotlight", "Health"],
    description:
      "Keep the nutrition for all your meals balanced and healthy, using our app, you get to track what you've eaten, and AI will give you reccomendations on what to eat to make sure you're not getting any defficienties, while also making sure there's zero overdosing on nutrients as well.",
    liveUrl:
      "https://foodmental-ei2xnubfj-rakontracks-projects.vercel.app/meal-analysis/breakfast",
  },
  {
    name: "PomoLock-In",
    repoLink: "https://github.com/RakOnTrack/Pomolock-in_Website",
    screenshot: "images/PomoLockin.png",
    tags: ["Spotlight", "Productivity"],
    description:
      "Adhd app to help users focus, by using the web camera to track if their face is facing their screen while they want to get work done. ",
    liveUrl: "https://pomolock-in-website.vercel.app/workmode",
  },
  {
    name: "Habit Bingo",
    repoLink: "",
    screenshot: "images/HabitBingo.png",

    tags: ["Spotlight", "Productivity"],
    description:
      "Gamify your habit building with the good ol game of Bingo! Enter the habits you want to work on and you'll get a generated bingo board, to check off your boxes, and a variable chance of getting a reward!",
    liveUrl: "https://habit-bingo-app.vercel.app/",
  },

  {
    name: "MindScape App",
    repoLink: "https://github.com/Ethanwang17/health-app",
    screenshot: logo,
    tags: ["Spotlight", "Health"],
    description:
      "No more relying on useless checkups with Doctor. Get your health data extracted from Apple watches, to send to splunk, for AI to analyze for any anomalies, and forms cancers. COMING SOON",
    liveUrl: "",
  },

  {
    name: "Tennis Court Booking App",
    repoLink: "",
    screenshot: "images/tennisCourtBooking.png",
    tags: ["Lifestyle"],
    description:
      "Developed a secure authentication system using JSON Web Tokens (JWT) and bcrypt for robust password encryption, enhancing user data security.",
    liveUrl: "https://tennis-app-woad.vercel.app/",
  },
  {
    name: "Line Manager Simulation",
    repoLink: "https://github.com/RakOnTrack/Line-Manager-Simulation",
    screenshot: "images/assemblyLineSimulator.jpg",
    tags: ["Automation"],
    description:
      "Designed a production line simulation that optimized order processing, reducing manual errors by 20% through streamlined processes.",
    liveUrl: "",
  },
  {
    name: "Mental Health App",
    // repoLink: "https://github.com/rakontrack/mental-health-app",
    screenshot: "images/MentalHealthApp.png",
    tags: ["Health"],
    description:
      "Developed a mental health app for addiction recovery, utilizing Figma for UI/UX design and Oracle Databases for secure data storage and compliance.",
    liveUrl: "https://www.figma.com/proto/gPQddyMeB61KkOb4bvNBSb/hack-it-up--Community-?node-id=0-1&t=23koyozIy1VuxjhQ-1",
  },
  {
    name: "Swiping Bots",
    repoLink:
      "https://github.com/RakOnTrack/pythonPortfolioProjects/tree/main/programming%20projects%20for%20github/swipeBots",
    screenshot: "images/swipingBots.jpg",
    tags: ["Automation"],
    description:
      "Built automated interactions on Tinder and Bumble using Selenium WebDriver, demonstrating skills in Python scripting and automation.",
    liveUrl: "",
  },
  {
    name: "This Portfolio Project Manager",
    repoLink: "",
    screenshot: "images/PortfolioManager.png",
    tags: ["Productivity"],
    description:
      "beautiful tool for designing your JSON data for your portfolio projects! \nChose your title, description, urls, tags, images, While viewing it all in real time. Coming Soon.",
    liveUrl: "",
  },
];

export default projects;
